export const LEGACY_OAUTH_OWNER_RECOVERY_PATH =
	"/api/oauth-clients/recover-legacy-owner";

export interface LegacyOAuthOwnerRecoveryRequest {
	oldBapId: string;
	newBapId: string;
}

export interface LegacyOAuthOwnerRecoveryResponse {
	migrated: number;
	clients: Array<{
		id: string;
		clientId: string;
	}>;
}

/**
 * Stable JSON body used for Bitcoin-auth signing and verification.
 */
export function serializeLegacyOAuthOwnerRecoveryBody(
	request: LegacyOAuthOwnerRecoveryRequest
): string {
	return JSON.stringify({
		oldBapId: request.oldBapId,
		newBapId: request.newBapId,
	});
}

export function parseLegacyOAuthOwnerRecoveryBody(
	bodyText: string
): LegacyOAuthOwnerRecoveryRequest {
	const parsed = JSON.parse(
		bodyText
	) as Partial<LegacyOAuthOwnerRecoveryRequest>;
	if (
		typeof parsed.oldBapId !== "string" ||
		parsed.oldBapId.trim().length === 0 ||
		typeof parsed.newBapId !== "string" ||
		parsed.newBapId.trim().length === 0
	) {
		throw new Error("oldBapId and newBapId are required");
	}

	return {
		oldBapId: parsed.oldBapId.trim(),
		newBapId: parsed.newBapId.trim(),
	};
}
